// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fphw","col":"styles_col__QllGU"};